import { Box } from '@grupoboticario/flora-react'

import { ReactComponent as LogoPL } from '../images/logo_pl.svg'

const Footer = () => {
  return (
    <Box css={{ marginTop: '32px' }}>
      <LogoPL />
    </Box>
  )
}

export default Footer
